import React from "react";
import {Routes, Route, useSearchParams} from "react-router-dom";
import Home from "./Pages/Home";
import Countries from "./Pages/Countries";
import Grades from "./Pages/Grades";
import Country from "./Pages/Country";
import Grade from "./Pages/Grade";
import Page from "./Pages/Page";
import Lessons from "./Pages/Lessons/Lessons";
import LessonExercise from "./Pages/Lessons/LessonExercise";
import LessonActivity from "./Pages/Lessons/LessonActivity";
import RedirectManager from "./Pages/RedirectManager";
import LessonTest from "./Pages/Lessons/LessonTest";
import Activities from "./Pages/Activities";
import Tests from "./Pages/Tests";
import { LessonActivityCorrected } from "./Pages/Lessons/LessonActivity/LessonActivityCorrected";
import { LessonActivityCorrectionSaved } from "./Pages/Lessons/LessonActivity/LessonActivityCorrectionSaved";
import { LessonTestCorrected } from "./Pages/Lessons/LessonTest/LessonTestCorrected";
import { LessonTestCorrectionSaved } from "./Pages/Lessons/LessonTest/LessonTestCorrectionSaved";
// import {NotAuthorized} from "./Pages/NotAuthorized";
import {useCookies} from "react-cookie";
import ExerciseBlocks from "./Pages/ExerciseBlocks/ExerciseBlocks";
import ExerciseBlock from "./Pages/ExerciseBlocks/ExerciseBlock";
import {LoginForm} from "./Pages/LoginForm";
import {validateAuthentication} from "./Utils/validateAcess";

const App = (props) => {
  let [searchParams] = useSearchParams();

  const [cookies, ] = useCookies([]);

  function isAuthorized(){
    const accessGranted = validateAuthentication(cookies, searchParams);

    if(accessGranted)
        console.log("Access granted");
    else
        console.log("Access denied");

    return accessGranted;
  }

  return (
      <Routes>
          <Route path="" element={<RedirectManager />} />
          <Route path="/:locale">
              <Route path="" element={<RedirectManager />} />
              <Route path="public">
                  <Route path="" element={<Home />} />
                  {
                      isAuthorized() ? (
                          <>



                              <Route path="countries" element={<Countries />} />
                              <Route path="country/:slug" element={<Country />} />
                              <Route path="grades" element={<Grades />} />
                              <Route path="grade/:id" element={<Grade />} />
                              <Route path="exerciseBlocks" element={<ExerciseBlocks />} />
                              <Route path="exerciseBlock/:id" element={<ExerciseBlock />} />
                              <Route path="activities" element={<Activities />} />
                              <Route path="tests" element={<Tests />} />
                              <Route path="lessons" element={<Lessons />} />
                              <Route
                                  path="lessons/:grade_id/:unit_id/:id/exercises"
                                  element={<LessonExercise />}
                              />
                              <Route
                                  path="lessons/:grade_id/:unit_id/:id/cumulative-activity"
                                  element={<LessonActivity />}
                              />
                              <Route
                                  path="lessons/:grade_id/:unit_id/:id/cumulative-activity/corrected"
                                  element={<LessonActivityCorrected />}
                              />
                              <Route
                                  path="lessons/:grade_id/:unit_id/:id/cumulative-activity/saved"
                                  element={<LessonActivityCorrectionSaved />}
                              />
                              <Route
                                  path="lessons/:grade_id/:unit_id/:id/test/corrected"
                                  element={<LessonTestCorrected />}
                              />
                              <Route
                                  path="lessons/:grade_id/:unit_id/:id/test/saved"
                                  element={<LessonTestCorrectionSaved />}
                              />
                              <Route
                                  path="lessons/:grade_id/:unit_id/:id/test"
                                  element={<LessonTest />}
                              />

                              <Route path=":env">
                                  <Route path="" element={<Home />} />

                                  <Route path="countries" element={<Countries />} />
                                  <Route path="country/:slug" element={<Country />} />
                                  <Route path="grades" element={<Grades />} />
                                  <Route path="grade/:id" element={<Grade />} />
                                  <Route path="exerciseBlocks" element={<ExerciseBlocks />} />
                                  <Route path="exerciseBlock/:id" element={<ExerciseBlock />} />
                                  <Route path="activities" element={<Activities />} />
                                  <Route path="tests" element={<Tests />} />
                                  <Route path="lessons" element={<Lessons />} />
                                  <Route
                                      path="lessons/:grade_id/:unit_id/:id/exercises"
                                      element={<LessonExercise />}
                                  />
                                  <Route
                                      path="lessons/:grade_id/:unit_id/:id/cumulative-activity"
                                      element={<LessonActivity />}
                                  />
                                  <Route
                                      path="lessons/:grade_id/:unit_id/:id/cumulative-activity/corrected"
                                      element={<LessonActivityCorrected />}
                                  />
                                  <Route
                                      path="lessons/:grade_id/:unit_id/:id/cumulative-activity/saved"
                                      element={<LessonActivityCorrectionSaved />}
                                  />
                                  <Route
                                      path="lessons/:grade_id/:unit_id/:id/test/corrected"
                                      element={<LessonTestCorrected />}
                                  />
                                  <Route
                                      path="lessons/:grade_id/:unit_id/:id/test/saved"
                                      element={<LessonTestCorrectionSaved />}
                                  />
                                  <Route
                                      path="lessons/:grade_id/:unit_id/:id/test"
                                      element={<LessonTest />}
                                  />
                              </Route>
                          </>

                      ) : <Route path="*" element={<LoginForm />} />
                  }

              </Route>
              <Route path="staging">
                  <Route path="" element={<Page element={<Home />} />} />
                  {
                      isAuthorized() ? (
                          <>
                              <Route
                                  path="countries"
                                  element={<Page element={<Countries />} />}
                              />
                              <Route
                                  path="country/:slug"
                                  element={<Page element={<Country />} />}
                              />
                              <Route path="grades" element={<Page element={<Grades />} />} />
                              <Route
                                  path="grade/:id"
                                  element={<Page element={<Grade />} />}
                              />

                              <Route path="exerciseBlocks" element={<Page element={<ExerciseBlocks />} />} />
                              <Route path="exerciseBlock/:id" element={<Page element={<ExerciseBlock />} />} />
                              <Route
                                  path="activities"
                                  element={<Page element={<Activities />} />}
                              />
                              <Route path="tests" element={<Page element={<Tests />} />} />
                              <Route path="lessons" element={<Page element={<Lessons />} />} />
                              <Route
                                  path="lessons/:grade_id/:unit_id/:id/exercises"
                                  element={<Page element={<LessonExercise />} />}
                              />
                              <Route
                                  path="lessons/:grade_id/:unit_id/:id/cumulative-activity"
                                  element={<Page element={<LessonActivity />} />}
                              />
                              <Route
                                  path="lessons/:grade_id/:unit_id/:id/cumulative-activity/corrected"
                                  element={<LessonActivityCorrected />}
                              />
                              <Route
                                  path="lessons/:grade_id/:unit_id/:id/cumulative-activity/saved"
                                  element={<LessonActivityCorrectionSaved />}
                              />
                              <Route
                                  path="lessons/:grade_id/:unit_id/:id/test/corrected"
                                  element={<LessonTestCorrected />}
                              />
                              <Route
                                  path="lessons/:grade_id/:unit_id/:id/test/saved"
                                  element={<LessonTestCorrectionSaved />}
                              />
                              <Route
                                  path="lessons/:grade_id/:unit_id/:id/test"
                                  element={<Page element={<LessonTest />} />}
                              />

                              <Route path=":env">
                                  <Route path="" element={<Page element={<Home />} />} />
                                  <Route
                                      path="countries"
                                      element={<Page element={<Countries />} />}
                                  />
                                  <Route
                                      path="country/:slug"
                                      element={<Page element={<Country />} />}
                                  />
                                  <Route path="grades" element={<Page element={<Grades />} />} />
                                  <Route
                                      path="grade/:slug"
                                      element={<Page element={<Grade />} />}
                                  />
                                  <Route
                                      path="activities"
                                      element={<Page element={<Activities />} />}
                                  />
                                  <Route path="tests" element={<Page element={<Tests />} />} />
                                  <Route
                                      path="lessons"
                                      element={<Page element={<Lessons />} />}
                                  />
                                  <Route
                                      path="lessons/:grade_id/:unit_id/:id/exercises"
                                      element={<Page element={<LessonExercise />} />}
                                  />
                                  <Route
                                      path="lessons/:grade_id/:unit_id/:id/cumulative-activity"
                                      element={<Page element={<LessonActivity />} />}
                                  />
                                  <Route
                                      path="lessons/:grade_id/:unit_id/:id/cumulative-activity/corrected"
                                      element={<LessonActivityCorrected />}
                                  />
                                  <Route
                                      path="lessons/:grade_id/:unit_id/:id/cumulative-activity/saved"
                                      element={<LessonActivityCorrectionSaved />}
                                  />
                                  <Route
                                      path="lessons/:grade_id/:unit_id/:id/test/corrected"
                                      element={<LessonTestCorrected />}
                                  />
                                  <Route
                                      path="lessons/:grade_id/:unit_id/:id/test/saved"
                                      element={<LessonTestCorrectionSaved />}
                                  />
                                  <Route
                                      path="lessons/:grade_id/:unit_id/:id/test"
                                      element={<Page element={<LessonTest />} />}
                                  />
                              </Route>

                          </>

                      ) : <Route path="*" element={<LoginForm />} />
                  }

              </Route>
          </Route>
      </Routes>
  )
}

export default App;
